import { useEffect, useState, useCallback } from 'react';
import api from '../utils/api';

/**
 * Polls /users/me/master-data-status and exposes the result to the rest of
 * the app. The Layout uses it to render the warning banner + the hard-block
 * modal; TaskDetail / MemberWorkspace use it to disable "Start" buttons.
 *
 * Refreshes every 60s and whenever the window regains focus so the banner
 * goes away the moment the employee finishes their profile (which they may
 * do in a different tab).
 */
export function useMasterDataStatus() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/users/me/master-data-status');
      setStatus(data);
    } catch (e) {
      // 401 already redirects via interceptor; anything else we just swallow
      // and try again next tick.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 60000);
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [refresh]);

  return { status, loading, refresh };
}
